import appleicon from '../../../assets/images/appleicon.png';
import playicon from '../../../assets/images/playicon.png';
import classes from './DownloadCard.module.css';

const DownloadCard = (props) => {
    return (

        <a href={props.downloadLink} target='_blank' rel="noreferrer" className={classes.DownloadLink}>
            <div className={classes.DownloadCard} data-aos="flip-up">
                <div className={classes.DownloadIcon}>
                    <img src={props.apple ? appleicon : playicon} alt={props.title} />
                </div>
                <div>{props.title}</div>
            </div>
        </a>

    );
}

export default DownloadCard;